import React, { FC } from 'react';
import { ReactComponent as Checkbox } from '../../../assets/Common/Checkbox.svg';

export const CheckboxIcon: FC = () => <Checkbox />;
